import { cn } from '@utils';
import './style.scss';
import { Link, To } from 'react-router-dom';

export interface CommonLinkProps {
  url: To;
  title: string;
  target?: string;
  className?: string;
  onClick?: () => void;
  type?: 'primary' | 'warning' | 'secondary';
  htmlLink?: boolean;
}

export const CommonLink = ({
  url,
  title,
  target,
  className,
  onClick,
  type = 'primary',
  htmlLink,
}: CommonLinkProps) => {
  if (htmlLink) {
    return (
      <a
        onClick={onClick}
        className={cn('common-link', [
          className || '',
          `common-link--${type}`,
        ])}
        href={url as string}
        target={target}
      >
        {title}
      </a>
    );
  }

  return (
    <Link
      onClick={onClick}
      className={cn('common-link', [
        className || '',
        `common-link--${type}`,
      ])}
      to={url}
      target={target}
    >
      {title}
    </Link>
  );
};
